if (!customElements.get('cross-sell-dots')) {
  customElements.define(
    'cross-sell-dots',
    class CrossSellDots extends HTMLElement {
      connectedCallback() {
        this.list = this.closest('.drawer__cross-sell')?.querySelector('.drawer__cross-sell-list');
        this.dots = Array.from(this.querySelectorAll('[data-index]'));
        this.items = this.list ? Array.from(this.list.children) : [];

        if (!this.list || this.dots.length === 0 || this.items.length === 0) return;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const item = this.items[Number(dot.dataset.index)];
            if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });

        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          root: this.list,
          threshold: 0.6,
        });
        this.items.forEach((item) => this.observer.observe(item));
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = this.items.indexOf(entry.target);
          this.dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
